import NutritionalInfo from './NutritionalInfo';
export default NutritionalInfo;
